import React from "react";

export default class EmptyComponent extends React.Component {
    render() {
        return null;
    }
}